import { render } from "./ForgotPasswordConfirm.vue?vue&type=template&id=530923f9"
import script from "./ForgotPasswordConfirm.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ForgotPasswordConfirm.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script